import type { SVGProps } from 'react';
import * as React from 'react';

const DataBookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="product-logo/data-book">
      <g id="Group 18">
        <path
          id="Vector"
          d="M13.2153 6.89919V18.5524C13.2153 19.2263 12.6701 19.7639 12.0038 19.7639C11.3299 19.7639 10.7923 19.2188 10.7923 18.5524V9.42065C10.7923 8.56502 9.87607 8.01227 9.11888 8.42115L1.59992 12.457C1.2289 12.6539 1.00174 13.04 1.00174 13.4565V21.1042C1.00174 21.7327 1.50906 22.24 2.13753 22.24H21.8625C22.491 22.24 22.9983 21.7327 22.9983 21.1118C22.9983 17.5605 22.9983 7.34594 22.9983 2.92391C22.9983 2.06828 22.0896 1.5231 21.3324 1.92441L13.8211 5.89969C13.45 6.09656 13.2153 6.48273 13.2153 6.90676V6.89919Z"
          fill="#494949"
        />
        <path
          id="Intersect"
          d="M9.11877 8.4211C9.87597 8.01221 10.7926 8.56547 10.7926 9.4211V21.3088C10.7927 21.8008 11.1556 22.1944 11.6022 22.1945H12.2155L12.0944 22.2404H2.13733C1.50895 22.2403 1.00159 21.7321 1.00159 21.1037V13.4563C1.00168 13.0399 1.22927 12.6541 1.60022 12.4572L9.11877 8.4211Z"
          fill="#636363"
        />
        <path
          id="Intersect_2"
          d="M13.2682 21.4072C13.2681 21.8614 12.905 22.2244 12.4508 22.2245H11.5719C11.1745 22.2244 10.8441 21.9252 10.8043 21.5322L10.7994 21.4599V18.6816C10.8636 19.2877 11.3739 19.7635 12.0035 19.7636C12.6698 19.7636 13.2153 19.2265 13.2155 18.5527L13.2682 21.4072Z"
          fill="#2F2F2F"
        />
      </g>
    </g>
  </svg>
);
export default DataBookIcon;
